import DynamicContainer from './DynamicContainer.vue'

export default DynamicContainer
